// 左侧导航
const NAVLIST = [
  {
    name: 'CourseVideo',
    title: '我的视频',
    iconName: 'iconicon',
    iconColor: '#409eff',
  },
  {
    name: 'CourseLive',
    title: '我的直播',
    iconName: 'iconicon1',
    iconColor: '#F56C6C',
  },
  {
    name: 'CourseTiku',
    title: '我的题库',
    iconName: 'iconxieboke',
    iconColor: '#f56c6c',
  },
  {
    name: 'CourseKnow',
    title: '考点必刷',
    iconName: 'iconxiajiangqushi',
    iconColor: '#e6a23c',
  },
  {
    name: 'CourseTask',
    title: '核心百题',
    iconName: 'iconxueshengkaoqin-01',
    iconColor: ' #67c23a',
  },
  {
    name: 'CourseHandout',
    title: '资料下载',
    iconName: 'icondownload',
    iconColor: '#409eff',
  },
];

// 课程名字
const COURSENAME = {
  1: '初级会计实务',
  2: '经济法基础',
  3: '中级会计实务',
  4: '中级经济法',
  5: '财务管理',
  6: '会计',
  7: '税法',
  8: '经济法',
  9: '财务成本管理',
  10: '审计',
  11: '公司战略和风险管理',
  12: '管理会计概论',
  13: '管理会计职业道德',
  14: '预算实务',
  15: '成本管理',
  16: '工业实操',
  17: '税法一',
  18: '税法二',
  19: '财务与会计',
  20: '涉税服务实务',
  21: '涉税服务相关法律',
  22: '基础知识',
  23: '专业技能',
  24: '行政职业能力,测验',
  25: '申论',
  26: '公务员面试课',
  27: '事业单位',
  28: '建设工程施工管理',
  29: '建设工程法规及相关知识',
  30: '二建建筑工程实务',
  31: '二建公路工程实务',
  32: '二建水利水电实务',
  33: '二建市政工程实务',
  34: '二建机电工程实务',
  35: '二建矿业工程实务',
  36: '法考',
  37: '药学专业知识一',
  38: '药学专业知识二',
  39: '药学综合知识与技能',
  40: '',
  41: '中药学专业知识一',
  42: '中药学专业知识二',
  43: '中药学综合知识与技能',
  44: '药事管理与法规',
};

const PROFESSIONIDLIST = {
    1: 1,
    2: 1,
    11:1,
    12:1,
    //中级开始
    23: 2,
    24: 2,
    25: 2,
    //cpa开始
    36: 3,
    37: 3,
    38: 3,
    39: 3,
    310: 3,
    311: 3,
    //管理会计开始
    412: 4,
    413: 4,
    414: 4,
    415: 4,
    //实操开始
    516: 5,
    //税务师
    617: 6,
    618: 6,
    619: 6,
    620: 6,
    621: 6,
    //健康管理师
    722: 7,
    723: 7,
    //执业西药师
    1437: 14,
    1438: 14,
    1439: 14,
    1444: 14,
    //执业中药师
    1541: 15,
    1542: 15,
    1543: 15,
    1544: 1415,
    //中级经济师
    2149: 21,
    2150: 21,
    2151: 21,
    2152: 21,
    2153: 21,
    2154: 21,
}

export { NAVLIST, COURSENAME ,PROFESSIONIDLIST }
